import { Card, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { useWorkflowCardStyles } from './workflow-card.styles';
import { decodeImageURL } from '../../../util/image-url';

export interface WorkflowCardProps {
  recipientName?: string;
  recipientLink?: string;
  recipientLabel?: string;
  deliveredByIconSrc?: string;
  deliveredByName?: string;
  deliveredByLabel?: string;
}

export function WorkflowCard({
  recipientLink,
  recipientName,
  deliveredByName,
  deliveredByIconSrc,
  deliveredByLabel,
  recipientLabel
}: WorkflowCardProps) {
  const classes = useWorkflowCardStyles();
  return (
    <Card className={classes.card} elevation={0}>
      <Grid container>
        <Grid size={6}>
          <p className={classes.label}>{recipientLabel ? recipientLabel : 'RECIPIENT'}</p>
          <p className={classes.recipientName}>
            {recipientName && recipientLink ? <Link to={recipientLink}>{recipientName}</Link> : recipientName}
          </p>
        </Grid>
        <Grid size={6}>
          <p className={classes.label}>{deliveredByLabel ? deliveredByLabel : 'DELIVERED BY'}</p>
          {deliveredByIconSrc ? (
            <img
              className={classes.deliveredByName}
              style={{ height: '4em', width: 'auto' }}
              src={decodeImageURL(deliveredByIconSrc)}
              alt={deliveredByName}
            />
          ) : (
            <p className={classes.deliveredByName}>{deliveredByName ? deliveredByName : ''}</p>
          )}
        </Grid>
      </Grid>
    </Card>
  );
}
